import { RegularButton } from 'pg-ui-library';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  p {
    margin: 0;
  }
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`;

export const HeaderTitle = styled.p`
  font-size: 30px;
  font-weight: 600;
  color: #1c1b3a;
`;

export const HeaderItemLeft = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const HeaderItemRight = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 2.7fr 1fr;
  gap: 30px;
  min-height: 800px;
  @media only screen and (max-width: 1200px) {
    display: grid;
    grid-template-columns: auto;
  }
`;

export const LeftGridContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  min-width: 0px;
`;

export const RightGridContent = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 500px;
  max-height: 90vh;
`;

export const CancelButton = styled(RegularButton)`
  margin: 0;
`;

export const InfoIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  width: 26px;
  height: 26px;
  background: #2dcafc;
  cursor: pointer;
  &:hover > #tooltip {
    display: inline-block;
  }
`;

export const InfoIcon = styled.img`
  height: auto;
`;

export const RelativeContainer = styled.div`
  position: relative;
  display: none;
`;

export const TooltipText = styled.span`
  min-width: 500px;
  background-color: #fff;
  color: #1c1b3a;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 20px;
`;

export const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  row-gap: 20px;
  flex-grow: 1;
  margin: 20px 10px 10px 10px;
  overflow-y: scroll;
  max-height: 800px;
  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ScrollableContainerEmpty = styled(ScrollableContainer)`
  justify-content: center;
`;

export const CartContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
`;

export const CartFooter = styled.div`
  display: flex;
  align-items: center;
  max-height: 50px;
  width: 100%;
  justify-content: space-between;
  padding: 0px 30px 0px 30px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 20px #00000029;
`;

export const CartFooterText = styled.p`
  font-weight: 600;
  font-size: 18px;
  padding: 20px;
`;
